// R4-5 (spec 2026-10-07): the only GT4SD algorithm_version values
// gt4sd-service accepts. Mirror of GT4SD_BUILTIN_CHECKPOINTS /
// GT4SD_ALLOWED_ALGORITHM_VERSIONS in models/gt4sd-service/main.py; any other
// value is rejected with 422. The first id per algorithm is the service
// default, which an empty algorithm_version selects. Pinned to the Python
// list by models/gt4sd-service/test_algorithm_version_allowlist.py.
//
// GT4SD RT Part D: these are LOCAL artifact ids resolved under
// GT4SD_RT_CKPT_DIR, not Hugging Face Hub ids. Both previous ids were Hub ids
// that do not exist, which is why GT4SD never generated anything.
//
// hugging_face carries an empty list on purpose (RT-6): it has no built-in
// checkpoint and runs only with customer weights, which arrive as a
// checkpoint_gcs_uri and never as an algorithm_version. The key stays because
// the service keeps it, and the drift test compares key sets.
export const GT4SD_CHECKPOINTS = Object.freeze({
  hugging_face: Object.freeze([]),
  regression_transformer: Object.freeze(['crippen_logp']),
});

// Part 1a open item 1: the Regression Transformer property token per checkpoint.
// Keys are lookup names (lowercase, no whitespace, no <>); values are the exact token
// the checkpoint's vocabulary uses, which gt4sd-service wraps as <token>. RT tokens are
// case-sensitive and an unknown one encodes as [UNK] without an error, so the wire
// value is always a value of this table. The property name stays logP everywhere else
// (registry, targets, UI label). Mirror of GT4SD_RT_PROPERTY_TOKENS in
// models/gt4sd-service/main.py; pinned by models/gt4sd-service/test_target_property_token.py.
// Keep this table in the object form below: test_algorithm_version_allowlist.py reads
// every array-valued freeze entry in this file as an algorithm.
export const GT4SD_RT_PROPERTY_TOKENS = Object.freeze({
  crippen_logp: Object.freeze({ logp: 'logp' }),
});

// The logP targets the service accepts, as [low, high]. Mirror of
// GT4SD_RT_TARGET_RANGE in models/gt4sd-service/main.py, which is the
// intersection of the artifact's own declared range ([-5.0, 18.17], from
// inference.json) with the registry's feasible_range for logP
// (src/ai/registry/properties.js). Outside it the request is a 422, so the
// client bounds the field rather than letting a row be built, stored and
// dispatched before the service refuses it.
//
// Accepting a value is not a claim the model will reach it: the acceptance
// sweep measured saturation near 3.4 logP from the default ibuprofen seed.
export const GT4SD_RT_TARGET_RANGE = Object.freeze([-5.0, 10.0]);

const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

/** Spelling-insensitive lookup: strip whitespace and <>, lowercase, then the exact stored token for
 * that checkpoint; null when the checkpoint does not condition on it. */
export function gt4sdTargetToken(name, algorithmVersion) {
  if (typeof name !== 'string' || typeof algorithmVersion !== 'string') return null;
  if (!has(GT4SD_RT_PROPERTY_TOKENS, algorithmVersion)) return null;
  const tokens = GT4SD_RT_PROPERTY_TOKENS[algorithmVersion];
  const key = name.replace(/[\s<>]/g, '').toLowerCase();
  return has(tokens, key) ? tokens[key] : null;
}
